<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 20 18" fill="none">
		<path
			d="M15.7497 0H18.8179L12.1165 7.62404L20 18H13.8288L8.99174 11.7087L3.46371 18H0.391134L7.55758 9.84375L0 0H6.32768L10.6953 5.75048L15.7497 0ZM14.6719 16.174H16.3711L5.402 1.73077H3.57671L14.6719 16.174Z"
			fill="#7B7B7B"
		/>
	</svg>
</template>
